/**
 * File: src/components/admin-revision-history.js
 * Mô tả: Component hiển thị danh sách lịch sử Revisions cấu hình và nút Rollback khôi phục bản cũ.
 * Liên quan: src/services/admin-config-service.js, src/pages/admin-page.js
 */

import { createElement } from '../utils/dom.js';
import { getRevisionHistory, rollbackToRevision } from '../services/admin-config-service.js';

export const renderAdminRevisionHistory = (gameId = 'ant-clash', onRollbackSuccess) => {
  const container = createElement('div', { className: 'admin-revision-history-container' });

  const history = getRevisionHistory(gameId);

  const historyItems = history
    .slice()
    .reverse()
    .map(
      (item) => `
      <div style="background: var(--bg-tertiary); padding: 1rem 1.25rem; border-radius: 8px; border: var(--border-glass); margin-bottom: 0.75rem; display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 0.5rem;">
        <div>
          <div style="font-weight: 700; color: var(--color-accent);">Revision #${item.revisionId} • v${item.version}</div>
          <div style="font-size: 0.85rem; color: var(--color-text-muted); margin-top: 0.25rem;">${item.note}</div>
          <div style="font-size: 0.75rem; color: var(--color-text-dim); margin-top: 0.25rem;">Bởi ${item.author} • ${new Date(item.publishedAt).toLocaleString('vi-VN')}</div>
        </div>
        <button class="btn btn-secondary rollback-btn" data-rev="${item.revisionId}" style="padding: 6px 12px; font-size: 0.8rem;">
          🔄 Rollback Bản Này
        </button>
      </div>
    `
    )
    .join('');

  container.innerHTML = `
    <div style="background: var(--bg-secondary); padding: 1.5rem; border-radius: var(--radius-lg); border: var(--border-glass);">
      <h3 style="font-size: 1.25rem; margin-bottom: 1rem;">📜 Lịch Sử Phiên Bản & Khôi Phục (Rollback)</h3>
      <div style="max-height: 350px; overflow-y: auto;">
        ${historyItems}
      </div>
    </div>
  `;

  container.querySelectorAll('.rollback-btn').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const revId = parseInt(btn.getAttribute('data-rev'));
      if (confirm(`Bạn có chắc chắn muốn khôi phục lại dữ liệu cấu hình từ Revision #${revId}?`)) {
        btn.disabled = true;
        btn.textContent = '⏳ Đang khôi phục...';
        const result = await rollbackToRevision(gameId, revId, 'Admin');
        btn.disabled = false;
        btn.textContent = '🔄 Rollback Bản Này';
        if (result.success) {
          alert(`${result.message}`);
          if (onRollbackSuccess) onRollbackSuccess();
        } else {
          alert(`❌ ${result.message}`);
        }
      }
    });
  });

  return container;
};
